import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title?: ReactNode;
  hint?: ReactNode;
}

/** 空状态（图标 + 标题 + 提示） */
export default function EmptyState({
  icon = '◇',
  title = '暂无数据',
  hint,
}: EmptyStateProps) {
  return (
    <div className="empty">
      {icon && <div className="empty__icon">{icon}</div>}
      {title && <div className="empty__title">{title}</div>}
      {hint && <div className="empty__hint">{hint}</div>}
    </div>
  );
}
